<template>
	<div>
		<PageBanner></PageBanner>

		<div id="title" class="fb_title"><span class="fb_eng_title">FACSCOPE B</span> 自动细胞计数仪</div>
		<SectionDivider class="progress" id="title"></SectionDivider>

		<div class="img_container2">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">自动细胞计数仪</p>
			<p class="p2">FACSCOPE B</p>
			<p class="p3">FACSCOPE B是一款基于明场显微镜的自动细胞计数仪。通过提供自动对焦、<br>
				自定义预设、各种计数模式和用户友好的软件等功能，<br>
				克服了传统血细胞计数的不便之处。</p>
			<img src="../assets/img/production/FacecopeB_2.png" class="facscopeb_img" />
		</div>
		<p class="exp3">FACSCOPE B是一款基于明场显微镜的自动细胞计数仪。通过提供自动对焦、
			自定义预设、各种计数模式和用户友好的软件等功能，
			克服了传统血细胞计数的不便之处。</p>
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img class="icon1" src="../assets/img/production/图标1.png" />
			<p class="main_features" style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 3vh;">先进的细胞检测技术</p>
		<p id="title" style="font-size: 18px;" class="text_1">FACSCOPE先进的细胞识别算法可以精确识别不规则和成团细胞，以及活细胞、死细胞和成活率。</p>

		<div style="display: flex;justify-content: center;align-items: center;">
			<div class="img_container3">
				<img src="../assets/img/production/1.png" />
				<img src="../assets/img/production/2.png" />
				<img src="../assets/img/production/3.png" />
				<p>不规则细胞</p>
				<p>成团细胞</p>
				<p>活/死细胞（活率）</p>
			</div>
			<div class="img_container3_1">
				<img src="../assets/img/production/1.png" style="width: 360px;height: auto;" />
				<p>不规则细胞</p>
				<img src="../assets/img/production/2.png" style="width: 360px;height: auto;" />
				<p>成团细胞</p>
				<img src="../assets/img/production/3.png" style="width: 360px;height: auto;" />
				<p>活/死细胞（活率）</p>
			</div>
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 10vh;">自动聚焦功能</p>
		<p id="title" style="font-size: 18px;" class="text_2">自动聚焦功能扫描多个焦点，自动选择最佳焦点。</p>

		<div style="display: flex;justify-content: center;align-items: center;">
			<div class="img_container4">
				<img src="../assets/img/production/4.1.jpg" class="img_4_1" />
				<img src="../assets/img/production/4.2.jpg" class="img_4_2" />
			</div>
		</div>

		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 10vh;">精确的计数结果</p>
		<p id="title" style="font-size: 18px;" class="text_3">计数体积越大，计数结果越可靠。FACSCOPE的计数体积比常规血细胞计数更多，能够获得更加准确的结果。</p>
		<div class="img_container5">
			<img src="../assets/img/production/5.png" />
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 10vh;">用户友好的功能</p>
		<p id="title" style="font-size: 18px;">不同预设 ▶</p>
		<div class="img_container6">
			<img src="../assets/img/production/6.png" class="img_6" />
		</div>
		<p class="preset">固定预设 ▶</p>
		<div class="img_container6_1">
			<img src="../assets/img/production/固定预设.jpg" class="img_6_1" />
		</div>
		<p class="preset">自定义预设 ▶</p>
		<p class="preset_content">可以根据用户需求自定义细胞大小/细胞成团率/细胞死活</p>
		<p id="title" style="font-size: 18px;margin-top: 5vh;">计数模式 ▶</p>
		<div class="img_container6_2">
			<img src="../assets/img/production/计数模式.jpg" class="img_6_2" />
		</div>
		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" style="font-size: 18px; margin-bottom: 15vh;" class="text_0">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'FacscopeB',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".img_container2, .img_container3, .img_container3_1, .img_container4, .img_container5, .img_container6, .img_container6_1, .img_container6_2"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.img_container2, .img_container3, .img_container3_1, .img_container4, .img_container5, .img_container6, .img_container6_1, .img_container6_2 {
		transform: translateY(300px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.img_container2 {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.y_img3 {
		margin-top: 20px;
		height: 450px;
		width: 1200px;
	}

	.img_container2 p {
		position: absolute;
	}

	.fb_title {
		font-size: 30px;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.fb_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.img_container2 .p1 {
		margin-right: 810px;
		margin-bottom: 200px;
		font-size: 28px;
	}

	.img_container2 .p2 {
		margin-right: 700px;
		margin-bottom: 100px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.img_container2 .p3 {
		margin-right: 400px;
		margin-top: 200px;
		font-size: 18px;
		line-height: 2;
	}

	.exp3 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.facscopeb_img {
		position: absolute;
		width: auto;
		height: 320px;
		margin-left: 600px;
	}

	.img_container3 {
		display: grid;
		grid-template-columns: 330px 330px 330px;
		grid-template-rows: 260px;
		text-align: center;
		grid-column-gap: 20px;
		grid-row-gap: 20px;
	}

	.img_container3 img {
		margin-top: 3.125rem;
		height: 220px;
		width: 330px;
	}

	.img_container3_1 {
		display: none;
	}

	.img_container4 {
		display: grid;
		grid-template-columns: 500px 500px;
		grid-template-rows: 300px;
		text-align: center;
		grid-column-gap: 20px;
	}

	.img_4_1 {
		margin-top: 3.125rem;
		height: 220px;
		width: 580px;
	}

	.img_4_2 {
		margin-top: 3.4rem;
		height: 205px;
		width: 580px;
	}

	.img_container5 {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.img_container5 img {
		margin-top: 3.125rem;
		height: 460px;
		width: 770px;
	}

	.img_container6 {
		margin-top: 5vh;
	}

	.img_container6, .img_container6_1 {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.img_6_1 {
		width: 720px;
		height: 190px;
	}

	.img_container6_2 {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.img_6_2 {
		width: 720px;
		height: 300px;
	}

	.preset {
		font-size: 15px;
		margin-left: calc(50% - 400px);
		margin-top: 5vh;
	}

	.preset_content {
		font-size: 15px;
		margin-left: calc(50% - 350px);
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.img_container2 .p1 {
			margin-right: 630px;
			font-size: 1.5rem;
		}

		.img_container2 .p2 {
			margin-right: 600px;
			font-size: 2rem;
		}

		.img_container2 .p3 {
			margin-right: 250px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.facscopeb_img {
			position: absolute;
			height: 250px;
			width: auto;
			margin-top: 20px;
		}

		.img_container3 {
			display: grid;
			grid-template-columns: 300px 300px 300px;
			grid-template-rows: 260px;
			text-align: center;
			grid-column-gap: 10px;
			grid-row-gap: 0;
		}

		.img_container3 img {
			margin-top: 2rem;
			height: 200px;
			width: 300px;
		}

		.img_container4 {
			display: grid;
			grid-template-columns: 400px 400px;
			grid-template-rows: 300px;
			text-align: center;
			margin-right: 70px;
		}

		.img_4_1 {
			margin-top: 3rem;
			height: 176px;
			width: 474px;
		}

		.img_4_2 {
			margin-top: 3.2rem;
			height: 164px;
			width: 474px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.fb_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.fb_eng_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.img_container2 .p1, .img_container2 .p2 {
			font-size: 1.2rem;
			margin-right: 200px;
			margin-top: 150px;
		}

		.img_container2 .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.facscopeb_img {
			position: absolute;
			height: 150px;
			width: auto;
			margin-top: 20px;
			margin-left: 200px;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_container3 {
			display: none;
		}

		.img_container3_1 {
			display: grid;
			grid-template-columns: 360px;
			text-align: center;
			grid-column-gap: 10px;
			grid-row-gap: 10px;
		}

		.img_container4 {
			display: grid;
			grid-template-columns: 400px;
			grid-template-rows: 250px;
			margin-right: 0;
		}

		.img_4_1, .img_4_2 {
			width: 400px;
			height: auto;
		}

		.img_container5 img {
			margin-top: 2rem;
			margin-right: 20px;
			height: 240px;
			width: auto;
		}

		.img_6 {
			width: 360px;
			height: auto;
		}

		.img_6_1 {
			width: 360px;
			height: 95px;
		}

		.img_6_2 {
			width: 360px;
			height: 150px;
		}

		.preset {
			font-size: 15px;
			margin-left: calc(50% - 160px);
			margin-top: 5vh;
		}

		.preset_content {
			font-size: 15px;
			margin-left: calc(50% - 160px);
		}

		.preset_content, .text_0, .text_1, .text_2, .text_3 {
			margin-right: 20px;
			text-indent: 2em;
			line-height: 2rem;
		}
	}

	@media screen and (max-width: 280px) {
		.img_container2 .p1, .img_container2 .p2 {
			margin-right: 120px;
		}
	}
</style>